import { useStyletron } from 'baseui'
import { PulseCounterBadge } from './styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

const CounterBadge = ({ pdlType, pdlState }) => {
  const [css] = useStyletron()
  const isPulse = usePulseScope()
  const isActive = pdlState === 'En service'

  if (isPulse) {
    return (
      <PulseCounterBadge $active={isActive}>
        <span>{pdlType || 'Linky'}</span>
        <span>·</span>
        <span>{pdlState || 'En service'}</span>
      </PulseCounterBadge>
    )
  }
  const badgeColor = isActive ? '#aac031' : '#aaabaf'

  return (
    <div
      className={css({
        backgroundColor: badgeColor,
        borderRadius: '0.25rem',
        padding: '0.25rem 0.5rem',
        color: 'white',
        fontSize: '0.75rem',
        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
      })}
    >
      <span>{pdlType || 'Linky'}</span>
      <span>{pdlState || 'En service'}</span>
    </div>
  )
}

export default CounterBadge
